import Image from '@tiptap/extension-image';
const inputRegex = /(?:^|\s)((?:~)((?:[^~]+))(?:~))$/;
export default Image.extend({
  addAttributes() {
    var _this$parent;
    return {
      ...((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.call(this)),
      isImageLoading: {
        default: false
      },
      imageData: {
        default: []
      },
      editorMaxWidth: {
        default: 0
      }
    };
  }
});